import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConfirmationService, LazyLoadEvent, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {
    DatastoreDto,
    EngineTagEventPersonalService, EngineTagEventService,
    EngineTagService,
    IHistoryEvent,
    Partner,
    TagDTO, TagEventDTO
} from '@tj/tj-dmp-lib-api';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Paginator} from '../../../components/paginator';
import {Subscription} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import {isTagJobFinished, TagJobService} from '../../../services/tag-job.service';

@Component({
    selector: 'dmp-tags-event',
    templateUrl: './tags-event.component.html',
    styleUrls: ['./tags-event.component.scss'],
    standalone: false
})
export class TagsEventComponent implements OnInit, OnDestroy {

    breadcrumb: Array<{ label: string }> = [];
    description: string;

    editPanel = false;
    isNew = false;

    form: UntypedFormGroup;
    submitted = false;

    group: DatastoreDto;
    partner: Partner;

    actual: IHistoryEvent;
    // Initialized to avoid ExpressionChangedAfterItHasBeenCheckedError on first CD cycle.
    data: IHistoryEvent[] = [];
    historyPaginator = new Paginator();
    reglesPaginator = new Paginator();
    datastore: DatastoreDto;
    id: number;
    items: MenuItem[];
    itemsRegle: any[];
    actualRegle: TagEventDTO;
    // Initialized to avoid ExpressionChangedAfterItHasBeenCheckedError on first CD cycle.
    regles: Array<TagEventDTO> = [];
    inprogress = false;
    private runSub: Subscription = null;

    constructor(private router: Router,
                private confirmationService: ConfirmationService,
                private translate: TranslateService,
                private messageService: MessageService,
                private engineTagService: EngineTagService,
                private engineTagEventService: EngineTagEventService,
                private engineTagEventPersonalService: EngineTagEventPersonalService,
                private tagJobService: TagJobService,
                private fb: UntypedFormBuilder) {
        this.translate.onLangChange.subscribe(() => this.rebuildTranslatedHeader());
        this.description = this.translate.instant('tagsEvent.description');
        this.items = [
            {
                label: this.translate.instant('tagsEvent.detailsMenuLabel'),
                command: () => {
                    this.router.navigate(['/h/tag/event', this.datastore.code, this.actual.idTagEvent, this.actual.timbre]);
                }
            }];
        this.itemsRegle = [
            {
                label: this.translate.instant('tagsEvent.detailSearchLabel'),
                tooltip: this.translate.instant('tagsEvent.detailSearchTooltip'),
                icon: 'pi pi-search',
                permission: 'DATAVIEWS.read',
                command: () => {
                    this.router.navigate(['/h/tag/event', this.datastore.code, this.actualRegle.id]);
                }
            },
            {
                label: this.translate.instant('tagsEvent.runLabel'),
                tooltip: this.translate.instant('tagsEvent.runTooltip'),
                icon: 'fas fa-play',
                permission: 'DATAVIEWS.edit',
                command: () => {
                    this.run(this.actualRegle);
                }
            }];
    }

    private rebuildTranslatedHeader(): void {
        this.breadcrumb = [
            {label: this.translate.instant('menu.dataviews.label')},
            {label: this.translate.instant('menu.dataviews.tag-events')}
        ];
        this.description = this.translate.instant('tagsEvent.description');
    }

    ngOnInit(): void {
        // Build translated breadcrumb after TranslateService is injected.
        this.rebuildTranslatedHeader();

        this.form = this.fb.group({
            id: [''],
            tenant: ['', Validators.required],
            partner: [''],
            name: ['', Validators.required],
            description: [''],
            enable: ['']
        });
    }

    datastoreChange(datastore: DatastoreDto) {
        this.datastore = datastore;
        this.updateListTable();
        this.loadHistorique();
    }

    private updateListTable() {
        if (this.datastore) {
            this.engineTagEventService.getAllRegle(this.datastore.code).subscribe(regles => {
                this.regles = regles;
            });
        } else {
            this.regles = [];
        }
    }

    onPageChange(event: any) {
        this.historyPaginator.first = event.first;
        this.historyPaginator.rows = event.rows;
        this.loadHistorique();
    }

    loadHistorique(event?: LazyLoadEvent) {
        if (this.datastore) {
            this.historyPaginator.loading = true;
            this.engineTagEventPersonalService.findHistoryEvent(this.datastore.code, this.historyPaginator.first / this.historyPaginator.rows, this.historyPaginator.rows, null, 'response')
                .subscribe((res) => {
                    this.data = res.body;
                    this.historyPaginator.loading = false;
                    this.historyPaginator.totalRecords = +res.headers.get('x-total-count');
                });
        } else {
            this.data = [];
        }
    }
    public splitTag(tags: string): string[] {
        if (tags) {
            return tags.split(', ');
        } else {
            return [];
        }
    }

    private delete(id: number, event) {
        /*
        const tag = this.data.find(t => t.id === id);
        if (tag) {
            this.confirmationService.confirm({
                message: `Êtes vous sur de supprimer le tag '${tag.name}' ?`,
                accept: () => {
                    this.engineTagService.deleteTag(this.datastore.code, id).subscribe(() => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: 'Le tag a bien été supprimé'
                        });
                        this.updateListTable();
                    });
                }
            });
        }

         */
    }

    doNouveau() {
        this.editPanel = true;
        this.isNew = true;
        this.initializeForm(null);
    }

    initializeForm(tag: IHistoryEvent) {
       /* this.form.patchValue({
            id: tag?.id,
            tenant: this.datastore?.code,
            partner: tag?.partner,
            name: tag?.name,
            description: tag?.description,
            enable: tag?.enable
        });*/
    }
    get f(): { [key: string]: AbstractControl } {
        return this.form.controls;
    }

    close() {
        this.editPanel = false;
    }

    private getTagDTO() {
        return {
            id: this.form.value.id,
            name: this.form.value.name,
            description: this.form.value.description,
            enable: this.form.value.enable,
            partners: this.form.value.partner ? [this.form.value.partner] : []
        } as TagDTO;
    }


    run(item: TagEventDTO) {
        const tenant = this.datastore.code;
        this.inprogress = true;
        // La règle s'applique en tâche de fond de l'engine : la modale d'attente suit la tâche jusqu'à sa fin.
        this.runSub = this.tagJobService.startRun(tenant, item.partner, item.id).pipe(
            switchMap(started => this.tagJobService.watch(tenant, started)),
            filter(isTagJobFinished)
        ).subscribe({
            next: job => {
                this.inprogress = false;
                if (job.status === 'FAILED') {
                    this.messageService.add({
                        severity: 'error',
                        summary: this.translate.instant('tagsEvent.runInterrupted',
                            {count: job.changes.toLocaleString('fr-FR')})
                    });
                }
                // La nouvelle application, en tête de l'historique.
                this.loadHistorique();
            },
            // Sans cela, un échec laissait la modale « Traitement en cours » bloquée à l'écran.
            error: () => this.inprogress = false
        });
    }

    ngOnDestroy(): void {
        // La règle continue de s'appliquer côté engine ; seul son suivi s'arrête avec la page.
        this.runSub?.unsubscribe();
    }
}
